import type { PlaylistMeta } from '../../repositories/playlists';

// AD-310: whenever a filter is on, what the table shows against what there is, so a filter
// over a field with gaps can never drop rows silently. The backend sends the counts with
// every filtered read; with no filter on, there is nothing to say and this renders nothing.

/**
 * "Showing 4 of 61 playlists · 57 have no country data". Each clause after the first appears
 * only when that filter actually left rows out.
 */
export const filterCountText = (meta: PlaylistMeta | null | undefined): string | null => {
  const counts = meta?.filterCounts;
  if (!counts) return null;

  const noun = counts.available === 1 ? 'playlist' : 'playlists';
  const parts = [`Showing ${counts.shown} of ${counts.available} ${noun}`];
  if (counts.noCountryData > 0) {
    parts.push(`${counts.noCountryData} ${counts.noCountryData === 1 ? 'has' : 'have'} no country data`);
  }
  if (counts.hiddenGeoVariants > 0) {
    parts.push(`${counts.hiddenGeoVariants} chart and country ${counts.hiddenGeoVariants === 1 ? 'playlist' : 'playlists'} hidden`);
  }
  return parts.join(' · ');
};

export const FilterCountLine = ({ meta }: { meta: PlaylistMeta | null | undefined }) => {
  const text = filterCountText(meta);
  if (!text) return null;
  return <p className="mb-2 text-sm font-medium text-neutral-700">{text}</p>;
};
